import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CountryProvider } from "./context/CountryContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Trips from "./pages/Trips";
import TripDetail from "./pages/TripDetail";
import Dispenses from "./pages/Dispenses";
import Deliveries from "./pages/Deliveries";
import MoneyOnRoad from "./pages/MoneyOnRoad";
import RoadExpenses from "./pages/RoadExpenses";
import Trucks from "./pages/Trucks";
import TruckDetail from "./pages/TruckDetail";
import Drivers from "./pages/Drivers";
import Customers from "./pages/Customers";
import Activities from "./pages/Activities";
import Evacuations from "./pages/Evacuations";
import Contracts from "./pages/Contracts";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Invoicing from "./pages/Invoicing";
import ControlTower from "./pages/ControlTower";
import Alerts from "./pages/Alerts";
import FleetMapPage from "./pages/FleetMapPage";

function AppRouter() {
  const location = useLocation();
  // Synchronously detect the Google OAuth fragment BEFORE ProtectedRoute / AuthContext runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="control-tower" element={<ControlTower />} />
        <Route path="map" element={<FleetMapPage />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="activities" element={<Activities />} />
        <Route path="evacuations" element={<Evacuations />} />
        <Route path="contracts" element={<Contracts />} />
        <Route path="trips" element={<Trips />} />
        <Route path="trips/:id" element={<TripDetail />} />
        <Route path="dispenses" element={<Dispenses />} />
        <Route path="deliveries" element={<Deliveries />} />
        <Route path="money" element={<MoneyOnRoad />} />
        <Route path="road-expenses" element={<RoadExpenses />} />
        <Route path="invoicing" element={<Invoicing />} />
        <Route path="invoicing/:id" element={<Invoicing />} />
        <Route path="trucks" element={<Trucks />} />
        <Route path="trucks/:id" element={<TruckDetail />} />
        <Route path="drivers" element={<Drivers />} />
        <Route path="customers" element={<Customers />} />
        <Route path="users" element={<Users />} />
        <Route path="reports" element={<Reports />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CountryProvider>
            <AppRouter />
          </CountryProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
